export const moviesKeys = {
  all: ['movies'] as const,
}
